import { defineComponent as _defineComponent } from 'vue';
import BootstrapVue from "bootstrap-vue";
import Vue, { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ObjectStoreRestrictionSpan',
    props: {
        isPrivate: Boolean,
    },
    setup(__props) {
        const props = __props;
        Vue.use(BootstrapVue);
        const text = computed(() => (props.isPrivate ? "private" : "sharable"));
        const title = computed(() => {
            if (props.isPrivate) {
                return "This dataset is stored on storage restricted to a single user. It cannot be shared, published, or added to Galaxy data libraries.";
            }
            else {
                return "This dataset is stored on storage that allows standard Galaxy sharing features. If you have sufficient Galaxy permissions to this dataset - the dataset can be published, shared, or added to data libraries within Galaxy.";
            }
        });
        return { __sfc: true, props, text, title };
    }
});
